// ===========================================================================
// Clinical Notes Transcriptor — módulo mobile-first (funciona en desktop y
// celular; en celular es el único ítem del sidebar).
// Paso 1: agenda del día de AdvancedMD (misma fuente que Pre-Visit / CDCI).
//
// ACCESO: lo gobierna la matriz RBAC y NADA MÁS — módulo
// `clinical_notes_transcriptor` (34) del catálogo, mapeado en
// app/AccessDenied/roleRoutePermissions.js.
//
// 2026-08-31: se retiró `TranscriptorGuardedRoute`, que exigía ADEMÁS estar en
// la allowlist compartida (REACT_APP_PREVISIT_EMPLOYEES). Mientras el módulo no
// estaba en el catálogo esa lista era el único control posible; al registrarse
// quedó como un segundo gate invisible que hacía que conceder el módulo desde
// Access Control no alcanzara. Mismo arreglo que Pre-Visit Planning, Patient
// Geography y CDCI.
//
// SIGUE VIGENTE el alcance de datos: el mapa empleado → profileId de AMD
// (common/access.js → providerAccess) hace que un médico mapeado vea SOLO sus
// citas. Eso es qué ve adentro, no si puede entrar.
// ===========================================================================
import React, { lazy } from "react";
import { TRANSCRIPTOR_BASE_PATH, TRANSCRIPTOR_ENABLED } from "./common/constants";

const TranscriptorSchedulePage = lazy(() => import("./pages/TranscriptorSchedulePage"));
const TranscriptorEncounterPage = lazy(() => import("./pages/TranscriptorEncounterPage"));

// El módulo resuelve su propio gating (2026-09-14): oculto de producción
// mientras se revisan los fallos de transcripción con audios largos — en
// producción no publica rutas y la URL cae en el catch-all del router. Ver
// TRANSCRIPTOR_ENABLED en common/constants.js.
export const clinicalNotesTranscriptorRoutes = TRANSCRIPTOR_ENABLED
  ? [
      {
        path: TRANSCRIPTOR_BASE_PATH,
        element: <TranscriptorSchedulePage />,
      },
      {
        path: `${TRANSCRIPTOR_BASE_PATH}/encounter/:appointmentId`,
        element: <TranscriptorEncounterPage />,
      },
    ]
  : [];

export { TRANSCRIPTOR_BASE_PATH, TRANSCRIPTOR_ENABLED } from "./common/constants";
